/** Shared centered-card layout for lighter content pages (legal, press, newsletter, 404). */
export default function SimplePage({ title, children, maxWidth = "760px" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {/* Padding via classes, not inline: global.css already narrows
          .tl-container to 20px below 860px, and an inline `padding` beat
          that media query. Every page built on SimplePage was therefore
          stuck at 40px container padding plus 40px card padding — 80px a
          side, leaving a 200px text column on a 360px screen, roughly
          fourteen characters a line. */}
      <div className="tl-container tl-simple-page" style={{ maxWidth }}>
        <div className="tl-card-light tl-simple-card" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <h1 className="tl-page-h1" style={{ fontFamily: "var(--font-serif)", fontSize: "34px", lineHeight: 1.15, color: "var(--color-ink)", margin: 0 }}>
            {title}
          </h1>
          {children}
        </div>
      </div>
    </div>
  );
}
